import React from 'react';

import { TextColors } from './color-picker';

interface ColorProps {
  color: TextColors;
  style: React.CSSProperties;
  onClick: () => void;
  selected?: boolean;
}

export const Color = ({ color, style, onClick, selected }: ColorProps) => {
  return (
    <div className={`color ${selected && 'selected'}`} onClick={onClick} style={{ backgroundColor: color, ...style }} />
  );
};
